import type { Strings } from "../state.js";
import { CallButton } from "./CallButton.js";
import { MuteButton } from "./MuteButton.js";

export interface FooterProps {
  active: boolean;
  muted: boolean;
  muteButton?: boolean;
  strings: Strings;
  onStart(): void;
  onStop(): void;
  onToggleMute(): void;
}

export function Footer({
  active,
  muted,
  muteButton,
  strings,
  onStart,
  onStop,
  onToggleMute,
}: FooterProps) {
  return (
    <div class="va-footer">
      <CallButton active={active} strings={strings} onStart={onStart} onStop={onStop} />
      {active && muteButton ? (
        <MuteButton muted={muted} strings={strings} onToggle={onToggleMute} />
      ) : (
        // Mute is opt-in (muteButton) and only meaningful once a session is active;
        // otherwise keep the reserved slot for layout stability.
        <div class="va-footer-slot" aria-hidden="true" />
      )}
    </div>
  );
}
